angular.module('bmsApp.directives').controller('VisitRiskAssessmentResponseModalCtrl', [
	'$scope',
	'$modalInstance',
	'visitType',
	'visit',
	'VisitRiskAssessmentResponseSvc',
	'$filter',
	function (
		$scope,
		$modalInstance,
		visitType,
		visit,
		VisitRiskAssessmentResponseSvc,
		$filter
		) {

		$scope.loading = true;
		$scope.visit = visit;
		$scope.title = 'Risk Assessment';
		if(angular.isObject(visit) && angular.isDefined(visit.job_date)){
			$scope.title = 'Risk Assessment - ' + $filter('amDateFormat')(visit.job_date, 'Do MMM YYYY');
			$scope.visitDate = $filter('amDateFormat')(visit.job_date, 'Do MMM YYYY')
		} else if (angular.isObject(visit) && angular.isDefined(visit.visit_date)){
			$scope.title = 'Risk Assessment - ' + $filter('amDateFormat')(visit.visit_date, 'Do MMM YYYY');
			$scope.visitDate = $filter('amDateFormat')(visit.visit_date, 'Do MMM YYYY')
		}
		VisitRiskAssessmentResponseSvc.index({
			filter: {
				VisitableBelongsTo: {
					visitType: visitType,
					visitId: angular.isObject(visit) ? visit.id : visit,
				},
			},
		}).then(function(response){
			$scope.risk_assessment_responses = response.data.risk_assessment_response_collection;
			$scope.loading = false;
		});

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};
		
	}]);
